import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Icon = ({ color, name, size, className, ...props }) => {
    const classButton = clsx(className, "icon", {
        [`icon--${color}`]: color,
        [`icon--${name}`]: name,
        [`icon--${size}`]: size,
    });

    return <i className={classButton} {...props} />;
};

Icon.propTypes = {
    color: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.string,
    className: PropTypes.string,
};

Icon.defaultProps = {
    color: "",
    name: "",
    size: "",
    className: "",
};

export default Icon;
